import React from 'react';
import { useSelector } from 'react-redux';
import ActiveScreening from '../ActiveScreening/ActiveScreening';
import ScreeningSummary from '../ScreeningSummary/ScreeningSummary';
import { FullRow } from '../../../layout/components';
const ScreeningSession = ({
  travellerIndex,
  traveller,
  onStartScreening,
  onFinishScreening,
  // conditionsCovered
}) => {
  const { token, index, isSubmitting } = useSelector((state) => state.screening);
  const isScreeningActive = travellerIndex === index;
  const showActiveScreening = token && isScreeningActive;

  return (
    <FullRow>
      <ActiveScreening
        show={showActiveScreening}
        traveller={traveller}
        travellerIndex={travellerIndex}
        onFinishScreening={onFinishScreening}
      />

      <ScreeningSummary
        show={!showActiveScreening}
        traveller={traveller}
        travellerIndex={travellerIndex}
        onStartScreening={onStartScreening}
        isScreeningActive={isScreeningActive}
        isSubmitting={isSubmitting}
        isScreening={!!token}
      />
    </FullRow>
  );
};

export default ScreeningSession;
